// Simple adapter to expose jQuery to the global scope for legacy code
import $ from 'jquery'

window.$ = window.jQuery = $

export default $